<template>
  <div>
    <div class="row-full prizes__rank">
      <div class="prizes__rank__cont">
        <div class="prizes__rank__cont__item">
          <h3>{{ getTranslations.home_prizes_and_leaderboards_rank }}<strong v-if="getRank">{{ numberFormatting(getRank.rank) }}</strong></h3>
        </div>
        <div class="prizes__rank__cont__item prizes__rank__cont__item--center">
          <h1>{{ getTranslations.home_prizes_and_leaderboards_leaderboard }}</h1>
          <img :src="userAvatar" alt="">
          <h2 v-if="getRank && getRank.displayPercentage">{{ getTranslations.home_prizes_and_leaderboards_top }} {{ getRank.displayPercentage }}%</h2>
          <h2 v-if="getRank[day] && getRank[day].displayPercentage">{{ getTranslations.home_prizes_and_leaderboards_top }} {{ getRank[day].displayPercentage }}%</h2>
          <div class="rank_update"><span>{{ getTranslations.home_prizes_and_leaderboards_last_updated }}</span> <span>{{ getDateFormat(refreshedDate, 'HH:mm') }}</span> <span>{{ getDateFormat(refreshedDate, 'MM/DD/YYYY') }} </span></div>
        </div>
        <div class="prizes__rank__cont__item">
          <h3>{{ getTranslations.home_prizes_and_leaderboards_points }}<strong v-for="(winner, index) in winners" :key="index" v-if="winner.msisdn === userDetails.msisdn">
            {{ numberFormatting(winner.points) }}
          </strong></h3>
        </div>
      </div>
    </div>
    <fb-share-rank v-if="winners && getRank && facebookFunctionality"
                   :ranks="getRank"
                   :winners="winners"
                   :updatePoints="updatePoints"
                   :type="type"
                   :day="day">
    </fb-share-rank>
    <div class="row-full prizes_list_v">
      <div class="prizes__rank-list prizes__content">
      <ul>
        <li v-for="(winner, index) in winners" :key="index"
            :class="[ (winner.msisdn === userDetails.msisdn)? 'active': '']">
          <div class="avatar">
            <span>{{ numberFormatting(winner.rank) }}</span>
            <div class="rank_rvp"> <img :src="winner.avatar" alt=""></div>
            <span>{{ winner.username }}</span>
          </div>
          <div class="score">
            <span>{{ numberFormatting(winner.points) }}</span>
          </div>
        </li>
      </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import NumbersFormattingMixin from '@/common/mixins/numbersFormatting';
import FbShareRank from './FbShareRank';

export default {
  name: 'prize-tab',
  props: ['day', 'type', 'winners', 'getRank', 'updatePoints', 'refreshedDate', 'getDateFormat'],
  mixins: [NumbersFormattingMixin],
  components: {
    FbShareRank,
  },
  computed: {
    ...mapState('common', [
      'userDetails',
      'facebookFunctionality',
      'userAvatar',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/prizesAndLeaderboards/PrizeTab.vue